import axios from 'axios';

// const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4002';
const baseURL = 'https://katibabkd.humanrights.or.tz';

const STATIC_FILE_PATH = /\/fs(thumbnails|manuals)\//;

const readStoredToken = (key) => {
    try {
        const raw = localStorage.getItem(key);
        if (!raw || raw === 'undefined' || raw === 'null') {
            return null;
        }

        try {
            const parsed = JSON.parse(raw);
            if (typeof parsed === 'string') {
                return parsed || null;
            }
            return null;
        } catch {
            // Another app on this origin may store a raw JWT. Never throw here —
            // a SyntaxError in this interceptor aborts the request before it is sent.
            return raw;
        }
    } catch {
        return null;
    }
};

const axiosInstance = axios.create({
    baseURL,
    adapter: 'fetch',
    fetchOptions: {
        cache: 'no-store'
    }
});

const refreshTokens = async () => {
    const refreshToken = readStoredToken('refreshToken');

    if (!refreshToken) {
        console.warn('[Auth] No refresh token available - forcing logout');
        localStorage.removeItem('accessToken');
        window.location.reload();
        return Promise.reject(new Error('No refresh token'));
    }

    try {
        const response = await axiosInstance.post('/refresh-token', { refreshToken });
        localStorage.setItem('accessToken', JSON.stringify(response.data.accessToken));
        return response.data.accessToken;
    } catch (error) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.reload();
        throw error;
    }
};

axiosInstance.interceptors.request.use(
    (config) => {
        const accessToken = readStoredToken('accessToken');

        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }

        const method = (config.method || 'get').toLowerCase();
        const requestUrl = config.url || '';
        if (method === 'get' && !STATIC_FILE_PATH.test(requestUrl)) {
            config.fetchOptions = { ...(config.fetchOptions || {}), cache: 'no-store' };
        }

        return config;
    },
    (error) => {
        console.error('[Request Error]', error);
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        if (error?.response?.status === 401 && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newAccessToken = await refreshTokens();
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        }

        if (error?.response?.status === 403) {
            console.warn('[Auth] 403 Forbidden - Invalid token detected');
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
